import I18n from "vue-i18n";
import Store from "store/store";
import axios from "plugins/axios";
import moment from "plugins/moment";
import Vue from "vue";

// Languages
import en_US from "locales/en_US";
import fr_FR from "locales/fr_FR";

Vue.use(I18n);

const i18n = new I18n({
    locale: Store.state.language.language,
    fallbackLocale: "en_US",
    messages: {
        en_US,
        fr_FR
    }
});

// Setting language to axios
const accepted = "" + i18n.locale + "; q=0.9, " + i18n.fallbackLocale;
axios.defaults.headers.common["Accept-Language"] = accepted;

// Setting language for moment
// (moment support only french and english for now)
moment.locale(Store.state.language.language);

export default i18n;